import "./web.js";
import "./list.js";
import { SPRest } from "../rest.js";
import { SiteScripts } from "./types.js";
export { SiteScripts, } from "./types.js";
Reflect.defineProperty(SPRest.prototype, "siteScripts", {
    configurable: true,
    enumerable: true,
    get: function () {
        return this.childConfigHook(function (_a) {
            var options = _a.options, baseUrl = _a.baseUrl, runtime = _a.runtime;
            return SiteScripts(baseUrl).configure(options).setRuntime(runtime);
        });
    },
});
//# sourceMappingURL=index.js.map